import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PcAdresseUmhaengenDto } from "@app/dto/pcadresse.umhaengen.dto";
import { PsDalAnschriftDto } from "@app/dto/ps.dal.anschrift.dto";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PcAdressenService {
    private _baseUrl = `${environment.apiHost}/${environment.apiBaseUrl}`;

    public constructor(
        private readonly http: HttpClient,
    ) { }

    public pcAdresseZuordnungVorhandeneFirmaVorhandenerStandort(pcAdresseUmhaengenDto: PcAdresseUmhaengenDto): Observable<string> {
        return this.http.post<string>(`${this._baseUrl}/pcadressen/umhaengen/existierendefirma-existierenderstandort`, pcAdresseUmhaengenDto);
    }

    public pcAdresseZuordnungVorhandeneFirmaNeuerStandort(pcAdresseUmhaengenDto: PcAdresseUmhaengenDto): Observable<string> {
        return this.http.post<string>(`${this._baseUrl}/pcadressen/umhaengen/existierendefirma-neuerstandort`, pcAdresseUmhaengenDto);
    }

    public pcAdresseZuordnungNeueFirmaNeuerStandort(pcAdresseUmhaengenDto: PcAdresseUmhaengenDto): Observable<string> {
        return this.http.post<string>(`${this._baseUrl}/pcadressen/umhaengen/neuefirma-neuerstandort`, pcAdresseUmhaengenDto);
    }
}